import { render, staticRenderFns } from "./DetalhesVencedoresItemTable.vue?vue&type=template&id=fe146840"
import script from "./DetalhesVencedoresItemTable.vue?vue&type=script&lang=ts"
export * from "./DetalhesVencedoresItemTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports